package location

sealed class GeoError : Throwable() {
    object PermissionDenied : GeoError()
    object PermissionAlwaysDenied : GeoError()
    object NotSupported : GeoError()
    object Timeout : GeoError()
    object Unavailable : GeoError()
    data class Unknown(override val cause: Throwable) : GeoError()
}
